// "Comparativa de precios" agrupa dos pantallas hermanas bajo una sola entrada del menú:
// contra la competencia (el comparador de tiendas) y contra el proveedor (SACCUM). Cada una
// tiene su interruptor; acá se resuelve cuáles están encendidas, con el mismo caché de sesión
// que usa el menú para no pedir el catálogo de interruptores en cada navegación.

var config = process.env;

const TTL_MS = 5 * 60 * 1000;
const CACHE_KEYS = { saccum: 'saccumSyncFeatureFlag', competitor: 'competitorPricesFeatureFlag' };
const FLAG_KEYS = { saccum: 'saccum_sync', competitor: 'precios_competencia' };

export const PRICE_COMPARISON_TABS = [
    { id: 'competitor', label: 'Contra la competencia', to: '/competitorPrices' },
    { id: 'saccum', label: 'Contra el proveedor (SACCUM)', to: '/priceReview' },
];

function readCache(key) {
    try {
        const parsed = JSON.parse(sessionStorage.getItem(key));
        return parsed && parsed.expiresAt > Date.now() ? Boolean(parsed.enabled) : null;
    } catch (error) {
        return null;
    }
}

function writeCache(key, enabled) {
    try {
        sessionStorage.setItem(key, JSON.stringify({ enabled, expiresAt: Date.now() + TTL_MS }));
    } catch (error) { /* sin sessionStorage se vuelve a pedir la próxima vez */ }
}

/** Las pestañas que corresponde mostrar, dados los interruptores. La activa siempre se muestra. */
export function visibleTabs(flags, active) {
    return PRICE_COMPARISON_TABS.filter((tab) => tab.id === active || Boolean(flags && flags[tab.id]));
}

/** A dónde lleva la entrada del menú: a la competencia si está encendida; si no, al proveedor. */
export function priceComparisonTarget(flags) {
    if (flags && flags.competitor) return '/competitorPrices';
    if (flags && flags.saccum) return '/priceReview';
    return null;
}

/** @returns {Promise<{saccum:boolean, competitor:boolean}>} ante cualquier error, todo apagado */
export function loadPriceComparisonFlags() {
    const cached = { saccum: readCache(CACHE_KEYS.saccum), competitor: readCache(CACHE_KEYS.competitor) };
    if (cached.saccum != null && cached.competitor != null) {
        return Promise.resolve(cached);
    }
    return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'configuration/settings/feature-flags', {
        headers: { 'access-token': localStorage.getItem('token') }
    })
        .then(res => res.json())
        .then(body => {
            if (body.error !== 0 || !body.data || !body.data.flags) {
                return { saccum: false, competitor: false };
            }
            const valueOf = (key) => {
                const flag = body.data.flags.find(f => f.key === key);
                return Boolean(flag && flag.value === true);
            };
            const flags = { saccum: valueOf(FLAG_KEYS.saccum), competitor: valueOf(FLAG_KEYS.competitor) };
            writeCache(CACHE_KEYS.saccum, flags.saccum);
            writeCache(CACHE_KEYS.competitor, flags.competitor);
            return flags;
        })
        .catch(() => ({ saccum: false, competitor: false }));
}
